import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export function initFormEventParticipant() : void {
    document.querySelectorAll<HTMLElement>('.js-form-event-participant').forEach($container => {
        new FormEventParticipant($container);
    });
}

type Repas = {
    id: number,
    name: string,
    isIncluded: boolean,
    isMorning: boolean,
    isIncludedGala: boolean,
    isAdditionalGala: boolean,
    price: number,
};
type UserType = 'adherent' | 'notAdherent' | 'student';

class FormEventParticipant {
    total = 0;

    stripe: stripe.Stripe|null = null;
    stripePaymentElements: stripe.elements.Elements|null = null;
    groupId: string|null = null;

    prices: { adherent: number, notAdherent: number, student: number };
    repas: Repas[];

    $container: HTMLElement;

    $form: HTMLFormElement;
    $formSections: HTMLElement[];
    $userTypeFields: HTMLInputElement[];
    $addParticipantButtons: HTMLButtonElement[];
    $addParticipantTemplate: HTMLTemplateElement;
    $participantsContainer: HTMLElement;

    $cartLinesContainer: HTMLUListElement;
    $cartTotalContainer: HTMLElement;

    constructor($container: HTMLElement) {
        this.$container = $container;

        this.$form = this.$container.querySelector('.js-form-event-participant-form') as HTMLFormElement;
        this.$formSections = Array.from(this.$form.querySelectorAll<HTMLElement>('[data-section]'));
        this.$userTypeFields = Array.from(this.$container.querySelectorAll<HTMLInputElement>('[data-user-type]'));
        this.$addParticipantButtons = Array.from(this.$form.querySelectorAll<HTMLButtonElement>('[data-add-participant-button]'));
        this.$addParticipantTemplate = this.$form.querySelector('[data-participant-template]') as HTMLTemplateElement;
        this.$participantsContainer = this.$form.querySelector('[data-participant-container]') as HTMLElement;

        this.prices = JSON.parse(this.$container.dataset.prices ?? '{ "adherentPrice": 9999, "price": 9999, "studentPrice": 9999 }');
        this.repas = JSON.parse(this.$container.dataset.repas ?? '[]');

        this.$cartLinesContainer = this.$container.querySelector('[data-cart-lines]') as HTMLUListElement;
        this.$cartTotalContainer = this.$container.querySelector('[data-cart-total]') as HTMLElement;

        // initialisation du fonctionnement des participants
        this.initParticipants();

        // Mise à jour des champs
        this.updateFields(this.$form);

        // Mise à jour des champs à chaque fois qu'un input change
        this.$form.querySelectorAll<HTMLInputElement>('input').forEach($input => {
            $input.addEventListener('change', () => {
                this.updateFields(this.$form);
            });
        });


        document.addEventListener("DOMContentLoaded", () => {
            const MASK_TEMPLATE = "__.__.__.__.__";
        
            document.addEventListener("focusin", (event) => {
                const target = event.target as HTMLInputElement;
        
                if (target.matches("input[type='tel']")) {
                    if (!target.value || target.value === MASK_TEMPLATE) {
                        target.value = MASK_TEMPLATE;
                        setTimeout(() => target.setSelectionRange(0, 0), 0); // Place le curseur au début
                    }
                }
            });
        
            document.addEventListener("input", (event) => {
                const target = event.target as HTMLInputElement;
        
                if (target.matches("input[type='tel']")) {
                    let input = target.value.replace(/\D/g, ""); // Supprime les caractères non numériques
                    let formattedValue = MASK_TEMPLATE.split(""); // Convertit en tableau pour modification
        
                    let index = 0;
                    for (let char of input) {
                        while (index < formattedValue.length && formattedValue[index] === ".") {
                            index++; // Saute les points
                        }
                        if (index < formattedValue.length) {
                            formattedValue[index] = char;
                            index++;
                        }
                    }
        
                    target.value = formattedValue.join("");
        
                    // Place le curseur au premier `_` disponible
                    let newCursorPosition = formattedValue.indexOf("_");
                    if (newCursorPosition === -1) newCursorPosition = formattedValue.length;
                    target.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            });
        
            document.addEventListener("keydown", (event) => {
                const target = event.target as HTMLInputElement;
        
                if (target.matches("input[type='tel']") && event.key === "Backspace") {
                    event.preventDefault(); // Empêche la suppression normale
        
                    let cursorPos = target.selectionStart || 0;
                    let formattedValue = target.value.split("");
        
                    // Si le curseur est juste après un ".", recule avant de supprimer
                    if (cursorPos > 0 && formattedValue[cursorPos - 1] === ".") {
                        cursorPos--;
                    }
        
                    // Remplace le dernier chiffre par "_" et met à jour l'affichage
                    while (cursorPos > 0) {
                        cursorPos--;
                        if (/\d/.test(formattedValue[cursorPos])) {
                            formattedValue[cursorPos] = "_";
                            break;
                        }
                    }
        
                    target.value = formattedValue.join("");
                    target.setSelectionRange(cursorPos, cursorPos);
                }
            });
        
            document.addEventListener("focusout", (event) => {
                const target = event.target as HTMLInputElement;
        
                if (target.matches("input[type='tel']") && target.value === MASK_TEMPLATE) {
                    target.value = ""; // Efface le masque si rien n’a été saisi
                }
            });
        });
        

        // Reset des erreurs lorsqu'on change de type d'utilisateur
        this.$userTypeFields.forEach($field => {
            $field.addEventListener('change', () => {
                this.resetErrors();
            });
        });

        // Lorsqu'on submit le formulaire
        this.$form.addEventListener('submit', evt => {
            evt.preventDefault();
            this.onFormSubmit();
        });
    }

    /**
     * Met à jour les champs en fonction de l'état du formulaire
     * 
     * @param {HTMLElement} $container Container utilisé pour chercher les champs
     * 
     * @return {void}
     */
    updateFields($container: HTMLElement): void {
        const currentUserType = this.getCurrentUserType();

        [
            'data-required-if-user-type',
            'data-readonly-if-user-type',
            'data-reset-if-user-type',
            'data-hide-if-user-type',
        ].forEach(attribute => {
            $container.querySelectorAll<HTMLElement>(`[${attribute}]`).forEach($element => {
                if (!$element.getAttribute(attribute)) {
                    return;
                }

                let requiredUserTypes: string[];
                try {
                    requiredUserTypes = JSON.parse($element.getAttribute(attribute) ?? '');
                } catch (err) {
                    requiredUserTypes = [$element.getAttribute(attribute) ?? ''];
                }

                // Si `$element` n'est pas un input, on récupère tous les inputs enfants
                const $fields = 'INPUT' === $element.tagName
                    ? [$element as HTMLInputElement]
                    : Array.from($element.querySelectorAll<HTMLInputElement>('input'));

                if ([
                    'data-required-if-user-type',
                    'data-readonly-if-user-type',
                    'data-reset-if-user-type',
                ].includes(attribute)) {
                    $fields.forEach($field => {
                        if ('data-required-if-user-type' === attribute) {
                            // Rendre les champs requis uniquement si `currentUserType` est dans `requiredUserTypes`
                            $field.toggleAttribute('required', requiredUserTypes.includes(currentUserType));
                            $field.closest('.form-col')?.querySelector('.form-label sup')?.classList.toggle('hidden', !requiredUserTypes.includes(currentUserType));
                        } else if ('data-readonly-if-user-type' === attribute) {
                            // Rendre les champs readonly uniquement si `currentUserType` est dans `requiredUserTypes`
                            $field.toggleAttribute('readonly', requiredUserTypes.includes(currentUserType));
                        } else if ('data-reset-if-user-type' === attribute) {
                            // Reset les champs uniquement si `currentUserType` est dans `requiredUserTypes`
                            if (!requiredUserTypes.includes(currentUserType)) {
                                return;
                            }

                            if (['radio', 'checkbox'].includes($field.type)) {
                                $field.checked = false;
                            } else {
                                $field.value = '';
                            }
                        }
                    });
                } else if ('data-hide-if-user-type' === attribute) {
                    // Masquer les elements uniquement si `currentUserType` est dans `requiredUserTypes`
                    $element.classList.toggle('hidden', !requiredUserTypes.includes(currentUserType));

                    // On enlève le `required` sur les éléments enfants et on les reset
                    $fields.forEach($field => {
                        // On ne met pas l'attribut `required` sur les champs qui ne le sont initialement pas
                        const initiallyRequired = '1' === $field.dataset.required;

                        $field.toggleAttribute('required', requiredUserTypes.includes(currentUserType) && initiallyRequired);
                        $field.parentElement?.querySelector('.form-label sup')?.classList.toggle('hidden', !requiredUserTypes.includes(currentUserType) && initiallyRequired);
                    });
                }
            });
        });

        // Ajouter des classes sur les elements uniquement si `currentUserType` est dans `requiredUserTypes`
        $container.querySelectorAll<HTMLElement>('[data-add-class-if-user-type]').forEach($element => {
            if (!$element.dataset.addClassIfUserType) {
                return;
            }

            let classToAdd: string;
            let requiredUserTypes: string[];
            try {
                const parsed = JSON.parse($element.dataset.addClassIfUserType);
                classToAdd = parsed.class;
                requiredUserTypes = parsed.user_type;
            } catch (err) {
                return;
            }

            $element.classList.toggle(classToAdd, requiredUserTypes.includes(currentUserType));
        });

        // Affichage du tag "Supplément de X€" pour les galas si l'utilisateur est un étudiant
        const $additionalGalaContainers = $container.querySelectorAll<HTMLElement>('[data-additional-gala]');
        $additionalGalaContainers.forEach($additionalGalaContainer => {
            const $parent = $additionalGalaContainer.closest('[data-gala-container]') as HTMLElement;
            const $additionalGalaTag = $parent.querySelector<HTMLElement>('[data-additional-gala-tag]');
            const $includedGalaYesRadio = $parent.querySelector('[data-included-gala-yes]') as HTMLInputElement;
            const $additionalGalaNoRadio = $parent.querySelector('[data-additional-gala-no]') as HTMLInputElement;

            $additionalGalaContainer.classList.toggle('hidden', !$includedGalaYesRadio.checked);
            $additionalGalaTag?.classList.toggle('hidden', 'student' !== currentUserType);

            if (!$includedGalaYesRadio.checked) {
                $additionalGalaNoRadio.checked = true;
            }
        });

        // Affichage des infos de facturation si celle-ci est identique à celle d'inscription
        const $invoiceContainer = $container.querySelector<HTMLElement>('[data-invoice-data]');
        const $differentInvoiceAddresseYesRadio = $container.querySelector<HTMLInputElement>('[data-different-invoice-address-yes]');
        if ($invoiceContainer && $differentInvoiceAddresseYesRadio) {
            $invoiceContainer.classList.toggle('hidden', !$differentInvoiceAddresseYesRadio.checked);

            $invoiceContainer.querySelectorAll<HTMLInputElement>('input').forEach($field => {
                // Rendre les champs requis uniquement si $invoiceContainer est affiché
                // Sauf sur invoice_company_name & invoice_siret
                if ($field.getAttribute('name') != 'form_inscription[invoice_company_name]' && $field.getAttribute('name') != 'form_inscription[invoice_siret]') {
                    $field.toggleAttribute('required', $differentInvoiceAddresseYesRadio.checked);
                    $field.closest('.form-col')?.querySelector('.form-label sup')?.classList.toggle('hidden', !$differentInvoiceAddresseYesRadio.checked);
                }
            });
        }

        // Affichage des infos de paiement plus tard si statut public
        const $payLaterContainer = $container.querySelector<HTMLElement>('[data-pay-later-data]');
        const $isStatutPublicYesRadio = $container.querySelector<HTMLInputElement>('[data-pay-later-yes]');
        if ($payLaterContainer && $isStatutPublicYesRadio) {
            $payLaterContainer.classList.toggle('hidden', !$isStatutPublicYesRadio.checked);
        }
        
        this.updateCart();
    }

    /**
     * Met à jour le panier avec les prix correspondant aux sélections dans le formulaire
     * 
     * @return {void}
     */
    updateCart(): void {
        const currentUserType = this.getCurrentUserType();

        type Line = { id?: number, name: string, price: number, count: number };
        const lines: Line[] = [];

        const $participantsContainers = [
            this.$formSections.filter($section => 'contact_details' === $section.dataset.section).pop() as HTMLElement,
            ...(Array.from(this.$participantsContainer.children) as HTMLElement[]),
        ];

        // Création des lignes pour chacun des participants
        $participantsContainers.forEach($participantContainer => {
            const includedGala = $participantContainer.querySelector<HTMLInputElement>('[data-included-gala-yes]')?.checked ?? false;
            const additionalGala = $participantContainer.querySelector<HTMLInputElement>('[data-additional-gala-yes]')?.checked ?? false;

            const participantRepas: Repas[] = [];

            // Toutes les lignes incluses pour tous les participants
            participantRepas.push(...this.repas.filter(repas => repas.isIncluded && !repas.isIncludedGala));

            // Repas de gala inclus pour le participant adhérent et non adhérent
            if ('student' !== currentUserType && includedGala) {
                participantRepas.push(...this.repas.filter(repas => repas.isIncludedGala));
            }

            // Tous les repas de gala sont supplémentaires pour les étudiants
            if ('student' === currentUserType && includedGala) {
                participantRepas.push(...this.repas.filter(repas => repas.isAdditionalGala));
            }

            // Repas de gala additionnel supplémentaire pour le participant adhérent
            if (additionalGala) {
                participantRepas.push(...this.repas.filter(repas => repas.isAdditionalGala));
            }

            participantRepas.forEach(repas => {
                const existingLineIndex = lines.map(line => line.id).indexOf(repas.id);

                if (existingLineIndex > -1) {
                    // Si la ligne du repas existe déjà, on additionne le prix à celle-ci
                    // lines[existingLineIndex].price = lines[existingLineIndex].price + repas.price;
                    lines[existingLineIndex].count++;
                } else {
                    // Sinon, on créé la ligne
                    lines.push({
                        id: repas.id,
                        name: repas.name,
                        price: repas.price,
                        count: 1,
                    });
                }
            });
        });

        // Suppression des anciennes lignes
        this.$cartLinesContainer.innerHTML = '';

        lines.push({
            name: 'Participants',
            price: this.prices[currentUserType],
            count: $participantsContainers.length,
        });

        // Ajout des nouvelles lignes
        const $lines: HTMLLIElement[] = [];
        lines.sort((a, b) => {
            // Tri du tablau pour avoir les participants en premier, suivis des repas inclus, puis du reste
            if (a.id === undefined && b.id !== undefined) {
                return -1;
            } else if (a.id !== undefined && b.id === undefined) {
                return 1;
            } else if (a.id === undefined && b.id === undefined) {
                return 0;
            } else if (a.price === 0 && b.price !== 0) {
                return -1;
            } else if (a.price !== 0 && b.price === 0) {
                return 1;
            }

            return 0;
        }).forEach(line => {
            const $nameDiv = document.createElement('div');
            $nameDiv.classList.add('article');
            $nameDiv.innerText = line.name + (line.count > 1 ? ' (x' + line.count + ')' : '');
    
            const $priceDiv = document.createElement('div');
            $priceDiv.classList.add('article-price');
            $priceDiv.innerText = (line.price * line.count).toString() + '€';
    
            const $li = document.createElement('li');
            $li.classList.add('line');
            $li.append($nameDiv, $priceDiv);

            $lines.push($li);
        });
        this.$cartLinesContainer.append(...$lines);

        // Modification du total
        this.total = lines.map(line => line.price * line.count).reduce((prev, current) => prev + current, 0);
        this.$cartTotalContainer.innerText = lines.map(line => line.price * line.count).reduce((prev, current) => prev + current, 0).toString() + '€';
    }

    /**
     * Retourne le type d'utilisateur sélectionné
     * 
     * @return {UserType}
     */
    getCurrentUserType(): UserType {
        let userType: UserType = 'adherent';

        this.$userTypeFields.forEach($field => {
            const fieldUserType = $field.dataset.userType ?? '';

            if ($field.checked && ['adherent', 'notAdherent', 'student'].includes(fieldUserType)) {
                userType = fieldUserType as UserType;
            }
        });

        return userType;
    }

    /**
     * Initialisation du fonctionnement des participants
     * 
     * @return {void}
     */
    initParticipants(): void {
        const maxParticipants = parseInt(this.$participantsContainer.dataset.max ?? '4');
        this.$addParticipantButtons.forEach($button => {
            // Au clique sur les boutons d'ajout de participants
            $button.addEventListener('click', () => {
                if (this.$participantsContainer.childElementCount >= maxParticipants) {
                    return;
                }

                const nbParticipants = parseInt(this.$participantsContainer.dataset.count ?? '0');

                const template = this.$addParticipantTemplate.innerHTML
                    .replaceAll('%field_index%', nbParticipants.toString())
                    .replaceAll('%field_index_plus_one%', (nbParticipants + 2).toString())
                    .replaceAll('%field_prefix%', 'participant');

                const $newParticipant = document.createElement('div');
                $newParticipant.classList.add(...this.$addParticipantTemplate.classList);
                $newParticipant.insertAdjacentHTML('beforeend', template);

                // Ajout evenement sur les boutons de suppression
                $newParticipant.querySelectorAll<HTMLButtonElement>('[data-remove-participant-button]').forEach($removeButton => {
                    $removeButton.addEventListener('click', () => {
                        $newParticipant.remove();

                        // Affichage du bouton d'ajout si on retombe sous le nombre max de participants
                        if (this.$participantsContainer.childElementCount < maxParticipants) {
                            this.$addParticipantButtons.forEach($btn => $btn.classList.remove('hidden'));
                        }

                        // Mise à jour des champs
                        this.updateFields(this.$form);
                    });
                });

                // Mise à jour des champs à chaque fois qu'un input change
                $newParticipant.querySelectorAll<HTMLInputElement>('input').forEach($input => {
                    $input.addEventListener('change', () => {
                        this.updateFields($newParticipant);
                    });
                });

                // Ajout du participant dans le DOM
                this.$participantsContainer.append($newParticipant);
                this.$participantsContainer.setAttribute('data-count', (nbParticipants + 1).toString());

                // Mise à jour des champs
                this.updateFields($newParticipant);

                // Masquage du bouton d'ajout si on atteint le nombre max de participants
                if (this.$participantsContainer.childElementCount >= maxParticipants) {
                    this.$addParticipantButtons.forEach($btn => $btn.classList.add('hidden'));
                }
            });
        });
    }

    /**
     * Fonction executée lorsque le formulaire est soumis
     * 
     * @return {void}
     */
    onFormSubmit(): void {
        this.showLoader();

        const formData = new URLSearchParams();
        formData.append('action', 'process_event_form');

        for (const pair of new FormData(this.$form)) {
            formData.append(pair[0], pair[1] as string);
        }

        const paymentMethod = formData.get('form_inscription[payment_method]');

        // Si Stripe est initialisé et que la méthode de paiement choisie est `stripe`
        if (paymentMethod && 'stripe' === paymentMethod && this.stripe && this.stripePaymentElements) {
            const $stripeErrorContainer = this.$form.querySelector<HTMLElement>('[data-error-for="stripe"]');

            this.resetErrors();

            this.stripe.confirmPayment({
                elements: this.stripePaymentElements,
                confirmParams: {
                    return_url: [location.protocol, '//', location.host, location.pathname, '/confirmation'].join(''),
                },
            }).then(response => {
                // Si succès => On est redirigé vers `return_url`

                if (response.error && 'card_error' === response.error.type && $stripeErrorContainer) {
                    $stripeErrorContainer.innerText = response.error.message ?? 'Une erreur s\'est produite. Veuillez ré-essayer plus tard.';
                }

                this.hideLoader();
            }).catch(() => {
                if ($stripeErrorContainer) {
                    $stripeErrorContainer.innerText = 'Une erreur s\'est produite. Veuillez ré-essayer plus tard.';
                }

                this.hideLoader();
            });

            return;
        } else if (paymentMethod && this.groupId && 'stripe' !== paymentMethod) {
            location.href = [location.protocol, '//', location.host, location.pathname, '/confirmation'].join('')
                + `?group_id=${this.groupId}&payment_method=${paymentMethod}`;
        }

        postData(script_var.ajax_url, formData).then(response => {
            if (response.success) {
                this.resetErrors();

                const btnSubmit = this.$form.querySelector('.btn-submit') as HTMLButtonElement;
                btnSubmit.textContent = 'Envoyer';

                this.groupId = response.data.group_id;

                this.$formSections.forEach($formSection => {
                    if ('payment' === $formSection.dataset.section) {
                        // Ajout de l'attribut `required` sur les champs de la section "payment"
                        $formSection.querySelectorAll<HTMLInputElement>('input').forEach($input => {
                            $input.setAttribute('required', 'required');
                        });

                        // Affichage de la section "payment"
                        $formSection.classList.remove('hidden');

                        // Affichage de stripe
                        const $stripeContainer = $formSection.querySelector<HTMLElement>('[data-payment-type="stripe"]');
                        if (!response.data.stripe) {
                            // Dans le cas où Stripe n'est pas fonctionnel
                            $stripeContainer?.remove();
                        } else if ($stripeContainer) {
                            this.stripe = Stripe(response.data.stripe.client_public);
                            const options = {
                                wallets: 'never', // Pas de Apple Pay et de Google Pay
                                layout: {
                                    type: 'accordion',
                                    defaultCollapsed: false,
                                    radios: true,
                                    spacedAccordionItems: false,
                                },
                            };
                            this.stripePaymentElements = this.stripe.elements({ clientSecret: response.data.stripe.client_secret });
                            const element = this.stripePaymentElements.create('payment', options);
                            element.mount('#payment-element');
                        }
                    } else {
                        // Désactivation de tous les champs
                        $formSection.querySelectorAll('input').forEach($input => {
                            $input.setAttribute('disabled', 'disabled');

                            // Suppression des boutons permettant de retirer un participant
                            $formSection.querySelectorAll<HTMLButtonElement>('[data-remove-participant-button]').forEach($removeParticipantButton => {
                                $removeParticipantButton.remove();
                            });
                        });

                        // Suppression des boutons permettant d'ajouter un participant
                        this.$addParticipantButtons.forEach($addParticipantButton => {
                            $addParticipantButton.remove();
                        });
                    }
                });
            } else {
                this.resetErrors();
                Object.keys(response.data.errors).forEach(fieldName => {
                    const errorMessage = response.data.errors[fieldName];
                    this.displayError(fieldName, errorMessage);
                });
            }
        }).catch(() => {
            this.resetErrors();
            this.displayError('form_inscription', 'Une erreur s\'est produite. Veuillez ré-essayer plus tard.');
        }).finally(() => {
            this.hideLoader();
        });
    }

    /**
     * Affiche le loader sur le formulaire
     * 
     * @return {void}
     */
    showLoader(): void
    {
        this.$form.classList.add('loading');
    }

    /**
     * Masque le loader sur le formulaire
     * 
     * @return {void}
     */
    hideLoader(): void
    {
        this.$form.classList.remove('loading');
    }

    /**
     * Affiche un message d'erreur
     * 
     * @param {string} fieldName
     * @param {string} errorMessage
     * 
     * @return {void}
     */
    displayError(fieldName: string, errorMessage: string): void
    {
        const $errorContainer = this.$form.querySelector<HTMLElement>(`[data-error-for="${fieldName}"]`);

        if ($errorContainer) {
            $errorContainer.innerText = errorMessage;
        }
    }

    /**
     * Reset toutes les erreurs du formulaire
     * 
     * @return {void}
     */
    resetErrors(): void {
        this.$form.querySelectorAll<HTMLElement>('[data-error-for]').forEach($errorContainer => $errorContainer.innerText = '');
    }
}
